import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import fetchProductData from "../Services/fetchProductData";
import useCurrentMasterCountry from "views/Components/Shared/hooks/useCurrentMasterCountry";
import { useBoundStore } from "useStore";

export default function useProductMasterData() {
  const { accessToken, user } = useAuth();

  const isAdmin = user.permissions.includes("ProductViewManage:Admin");
  const isViewer = user.permissions.includes("ProductViewManage:View");

  const mainCountry = useCurrentMasterCountry();
  const mainCountryId = mainCountry?.id;
  const paginationModel = useBoundStore(
    (state) => state.productMasterPaginationModel,
  );

  const search = useBoundStore((state) => state.productMasterSearch);
  const selectedBrand = useBoundStore(
    (state) => state.productMasterSelectedBrand,
  );

  const selectedOwner = useBoundStore(
    (state) => state.productMasterStSelectedOwners,
  );
  const selectedCategoryPath = useBoundStore(
    (state) => state.productMasterSelectedCategory,
  );
  const selectedKam = useBoundStore((state) => state.productMasterSelectedKam);

  // const showInactive = useBoundStore(
  // 	(state) => state.productMasterShowInactive
  // );
  let userFilter = null;
  if (isViewer && !isAdmin) {
    userFilter = user.name;
  }
  const { page, pageSize } = paginationModel;

  const ProductDataQuery = useQuery({
    queryKey: [
      "productMasterData",
      mainCountryId,
      page,
      pageSize,
      selectedBrand,
      search,
      selectedOwner,
      selectedCategoryPath,
      userFilter,
      selectedKam,
      // showInactive,
    ],
    queryFn: () =>
      fetchProductData({
        accessToken,
        mainCountry,
        paginationModel,
        selectedBrand,
        search,
        selectedOwner,
        selectedCategoryPath,
        userFilter,
        selectedKam,
        // showInactive,
      }),
    enabled: !!mainCountryId,
    staleTime: Infinity,
    retry: false,
    placeholderData: (previousData) => previousData,
  });

  return ProductDataQuery;
}
